import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { QuotesService } from '../../../core/data/services/quotes.service';

export const quoteExistsGuard: CanActivateFn = (route, state) => {
    const quotesService = inject(QuotesService);
    const router = inject(Router);

    // Skip check on internal navigation (from home page or other screens)
    if (router.navigated) {
        return true;
    }

    if (quotesService.currentQuote) {
        return true;
    }

    return router.createUrlTree(['/']);
};
